/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./poll');
require('./components/Pages/SinglePage');

require('./other');
require('./menu');

// commented out as it does not seem like we are using the js part
// Video.js
// require('video.js'); // 5500kb